module.exports = __webpack_public_path__ + "img/triple_crush.banner.f7c0233f.jpg";